/* global Swal */
export const RECAPTCHA_ERROR = "請確認網路環境後再試一次（RG）";

// Obtain a fresh token for each submission; never continue a timed-out request.
export default async function requestRecaptchaToken(vm, action) {
  let timer;
  let expired = false;
  try {
    const token = await Promise.race([
      (async () => {
        await vm.$recaptchaLoaded();
        if (expired) throw new Error("expired");
        return vm.$recaptcha(action);
      })(),
      new Promise((resolve, reject) => {
        timer = setTimeout(() => {
          expired = true;
          reject(new Error("timeout"));
        }, 15000);
      }),
    ]);
    if (typeof token !== "string" || !token.trim()) throw new Error("empty");
    return token;
  } catch {
    Swal.fire({
      icon: "error",
      text: RECAPTCHA_ERROR,
      confirmButtonText: "確定",
      heightAuto: false,
    });
    return null;
  } finally {
    clearTimeout(timer);
  }
}
